import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { sampleEmployeeData } from "core/json/sample_data";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { format, parse } from "date-fns";
import { all_routes } from "Router/all_routes";
import { importEmployyeValidationSchema } from "./Data/importEmployeeValidation";
import * as Yup from "yup";
import { Table } from "antd";
import { generateExcel } from "./Data/ImportSample";
import {
  useFormattedCountryeOption,
  useFormattedCPFContributionOption,
  useFormattedNationalOption,
  useFormattedPassTypeOption,
  useFormattedRaceOption,
  useFormattedResidentialTypeOption,
  useFormattedBankOption,
  useFormattedPaymodeOption,
  useFormattedProjectOption,
  useFormattedWorkingDaysTypeOption,
  useFormattedLocaionOption,
  useFormattedaAcadamicsOption,
  useFormattedCompanyOption,
  useFormattedMomTradeOption,
  useFormattedTradeOption,
  useFormattedLevyAmountTypesOption,
  useFormattedLevyTypesOption,
  useFormattedShiftPolicyOption2,
  useFormattedForeginerLevyTypesOption,
  useFormattedLeaveTypesOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import {
  useFormattedDepartmentOption,
  useFormattedDesignationOption,
  useFormattedEmpContractOption,
  useFormattedEmpGroupOption,
  useFormattedEmploymentTypeOption,
  useFormattedEmpStatusOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { employeeColumnMap } from "./Data/import/employeeColumnMap";
import { useCreateOrModifyEmployeeMutation } from "AppQuries/employee/add-employee";
import { toast } from "core/Operations/toast";
import { useImportEmployeesMutation } from "AppQuries/employee/import-employee";
import {
  getCurrentFormattedDate,
  parseExcelDateToISO,
} from "core/Operations/dateFormat";
import { transformExcelToLeaveDetails } from "./Data/import/leaveMapping";
import { BackIcon } from "Components/UI/Icon/Icons";

const ImportEmployee = () => {
  const userData = useSelector(loggedInUser);

  const companyCode = userData?.companyCode;
  const navigate = useNavigate();
  const [optionData, setOptionData] = useState({
    genders: [
      { label: "Male", value: "M" },
      { label: "Female", value: "F" },
      { label: "Others", value: "O" },
    ],
    marriagestatus: [
      { label: "Single", value: "Single" },
      { label: "Married", value: "Married" },
      { label: "Widowed", value: "Widowed" },
    ],
    boolOptions: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    SkilledOrUnskilledOptions: [
      { label: "Skilled", value: "S" },
      { label: "UnSkilled", value: "U" },
    ],
    prcpfTypeOptions: [
      { label: "Full", value: "F" },
      { label: "Graduate", value: "G" },
    ],
    salaryTypeOptions: [
      { label: "Monthly", value: "Monthly" },
      { label: "Daily", value: "Daily" },
      { label: "Hourly", value: "Hourly" },
    ],
    workingMode: [
      { label: "Full Time", value: "Full Time" },
      { label: "Part Time", value: "Part Time" },
    ],
    eatingHabit: [
      { label: "Veg", value: "Veg" },
      { label: "Non Veg", value: "Non Veg" },
      { label: "Veg & Non Veg", value: "Veg &  Non Veg" },
    ],
  });
  const raceOptions = useFormattedRaceOption(companyCode);
  const passTypeOptions = useFormattedPassTypeOption(companyCode);
  const groupOptions = useFormattedEmpGroupOption(companyCode);
  const employmentStatusOptions = useFormattedEmpStatusOption(companyCode);
  const employeeLeaveOptions = useFormattedLeaveTypesOption(companyCode);
  const empTypeOptions = useFormattedEmpTypeOption(companyCode);
  const nationalities = useFormattedNationalOption(companyCode);
  const residentialTypeOptions = useFormattedResidentialTypeOption(companyCode);
  const contributeOptions = useFormattedCPFContributionOption(companyCode);
  const countryOptions = useFormattedCountryeOption(companyCode);
  const paymodeOptions = useFormattedPaymodeOption(companyCode);
  const bankOptions = useFormattedBankOption(companyCode);
  const projectOptions = useFormattedProjectOption({
    companyCode: companyCode,
    locationCode: userData?.locationCode,
  });
  const workingDaysType = useFormattedWorkingDaysTypeOption(companyCode);
  const companyOptions = useFormattedCompanyOption({
    userId: userData?.userID,
  });

  const locationOptions = useFormattedLocaionOption(companyCode);
  const departmentOptions = useFormattedDepartmentOption(companyCode);
  const designationOptions = useFormattedDesignationOption(companyCode);
  const acadamicOptions = useFormattedaAcadamicsOption(companyCode);
  const momTradeOptions = useFormattedMomTradeOption(companyCode);
  const netcoTradeOptions = useFormattedTradeOption(companyCode);
  const employmentTypeOptions = useFormattedEmploymentTypeOption(companyCode);
  const levyAmountTypeOptions = [
    {
      id: 1,
      label: "None",
      value: "None",
    },
    {
      id: 2,
      label: "Daily",
      value: "Daily",
    },
    {
      id: 3,
      label: "Monthly",
      value: "Monthly",
    },
  ]; //useFormattedLevyAmountTypesOption(companyCode);
  const levyTypeOptions = useFormattedForeginerLevyTypesOption(companyCode); // useFormattedLevyTypesOption(companyCode);
  const contarctTypeOptions = useFormattedEmpContractOption(companyCode);
  const defaultShiftOptions = useFormattedShiftPolicyOption2({
    companyCode: companyCode,
    locationCode: userData?.locationCode,
  });

  const [employeeLeaveColumnMap, setEmployeeLeaveColumnMap] = useState({});

  useEffect(() => {
    setOptionData({
      ...optionData,
      race: raceOptions,
      passTypeOptions,
      group: groupOptions,
      empStatus: employmentStatusOptions,
      nationalities: nationalities,
      residentials: residentialTypeOptions,
      contributeOptions: contributeOptions,
      countryOptions: countryOptions,
      empTypeOptions: empTypeOptions,
      paymodeOptions: paymodeOptions,
      bankOptions: bankOptions,
      projectOptions: projectOptions,
      workingDaysType: workingDaysType,
      locationOptions: locationOptions,
      departmentOptions: departmentOptions,
      designationOptions: designationOptions,
      acadamicOptions: acadamicOptions,
      companyOptions: companyOptions,
      momTradeOptions,
      netcoTradeOptions,
      employmentTypeOptions,
      levyAmountTypeOptions,
      levyTypeOptions,
      contarctTypeOptions,
      defaultShiftOptions,
      employeeLeaveOptions,
    });

    // if (
    //   Object.keys(employeeLeaveColumnMap).length === 0 &&
    //   employeeLeaveOptions?.length > 0
    // ) {
    //   setEmployeeLeaveColumnMap({
    //     ...employeeLeaveColumnMap,
    //     employeeLeaveOptions: employeeLeaveOptions,
    //   });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    raceOptions?.length,
    passTypeOptions?.length,
    groupOptions?.length,
    employmentStatusOptions?.length,
    nationalities?.length,
    residentialTypeOptions?.length,
    contributeOptions?.length,
    countryOptions?.length,
    empTypeOptions?.length,
    paymodeOptions?.length,
    bankOptions?.length,
    projectOptions?.length,
    workingDaysType?.length,
    locationOptions?.length,
    departmentOptions?.length,
    designationOptions?.length,
    acadamicOptions?.length,
    companyOptions?.length,
    momTradeOptions?.length,
    netcoTradeOptions?.length,
    employmentTypeOptions?.length,
    levyAmountTypeOptions?.length,
    levyTypeOptions?.length,
    contarctTypeOptions?.length,
    defaultShiftOptions?.length,
    employeeLeaveOptions?.length,
    companyCode,
  ]);

  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [employeeData, setEmployeeData] = useState(null);
  const validationSchema = Yup.array().of(importEmployyeValidationSchema);

  const { mutate: importEmployee } = useImportEmployeesMutation();

  const flattenJson = (data) => {
    const result = {};
    const recurse = (cur, prop) => {
      if (Object(cur) !== cur || Array.isArray(cur)) {
        result[prop] = Array.isArray(cur) ? JSON.stringify(cur) : cur;
      } else {
        for (const key in cur) {
          recurse(cur[key], prop ? `${prop}_${key}` : key);
        }
      }
    };
    recurse(data, "");
    return result;
  };

  const handleDownloadSample = () => {
    const flatData = flattenJson(sampleEmployeeData);
    const headers = Object.keys(flatData);
    const sample = [headers.map((key) => flatData[key])];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sample]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Sample_Employee.xlsx");
  };

  const [empData, setEmpData] = useState();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      setUploadStatus("Processing...");
      setUploadedFileName(file.name);
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const empDetails = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      const sheetName2 = workbook.SheetNames[1];
      const leaveSheetName = workbook.SheetNames[2];
      const worksheet2 = workbook.Sheets[sheetName2];
      const workSheetLeave = workbook.Sheets[leaveSheetName];
      const courseDetails = XLSX.utils.sheet_to_json(worksheet2, {
        defval: "",
      });

      const leaveDetails = XLSX.utils.sheet_to_json(workSheetLeave, {
        defval: "",
      });

      const leave = transformExcelToLeaveDetails(
        leaveDetails,
        employeeLeaveOptions,
        userData?.userName
      );

      // Convert headers to internal keys
      const mappedData = empDetails.map((row) => {
        const mappedRow = {};
        for (let header in row) {
          const key = employeeColumnMap[header];
          if (key) {
            mappedRow[key] = row[header];
          }
        }

        return mappedRow;
      });

      const courseMappedData = courseDetails.map((row) => {
        const mappedRow = {
          isDefault: true,
          isActive: true,
          createUser: userData?.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData?.userName,
          modifyDate: getCurrentFormattedDate(),
        };
        for (let header in row) {
          const key = employeeColumnMap[header];
          if (key) {
            mappedRow[key] = row[header];
          }
        }
        return mappedRow;
      });

      const finalData = mappedData?.map((data) => {
        let salaryType =
          optionData?.salaryTypeOptions?.find(
            (opt) => opt?.label === data?.salaryType
          )?.value ?? "";

        let passCode = data?.passCode;
        //   optionData?.passTypeOptions?.find(
        //     (opt) => opt?.label === data?.passCode
        //   )?.value ?? 0;

        const passIssueDate =
          parseExcelDateToISO(data?.passIssuedDate, "yyyy-MM-dd") ?? "";
        const passExpiryDate = parseExcelDateToISO(
          data?.passExpiryDate,
          "dd/MM/yyyy"
        );

        const certificationsDetails = courseMappedData
          .filter((course) => course?.uniqueId === data?.uniqueId)
          .map((course) => ({
            ...course,
            companyCode: userData?.companyCode,
            code: 0,
            employeeCode: 0,
            certificateNumber: course?.certificateNumber?.toString() ?? "",
            issueDate:
              parseExcelDateToISO(course?.issueDate, "yyyy-MM-dd") ?? "",
            expiryDate:
              parseExcelDateToISO(course?.expiryDate, "yyyy-MM-dd") ?? "",
          }));

        const empLeaveDetails = leave
          .filter((leaveDetail) => leaveDetail?.uniqueId === data?.uniqueId)
          .map((leaveDetail) => ({
            ...leaveDetail,
            companyCode: userData?.companyCode,
            employeeCode: 0,
          }));

        const passTypeDetails = [
          {
            companyCode: userData?.companyCode,
            employeeCode: 0,
            passTypeID: 0,
            passCode:
              optionData?.passTypeOptions?.find(
                (opt) => opt?.label === data?.passCode
              )?.value ?? 0,
            nricNumber: data?.nricNumber,
            photoIdBarcode: "",
            issuedDate:
              parseExcelDateToISO(data?.passIssueDate, "yyyy-MM-dd") ?? "",
            sector: data?.sector,
            dateOfApplication: "",
            idExpiryDate: passExpiryDate,
            sPassNumber: data?.sPassNumber,
            workPermitNumber: data?.workPermitNumber?.toString() ?? "",
            workPermitRenewalDate:
              parseExcelDateToISO(data?.workPermitRenewalDate, "yyyy-MM-dd") ??
              "",
            levyAmountTypes:
              optionData?.levyAmountTypeOptions
                ?.find((opt) => opt?.label === data?.levyAmountTypes)
                ?.value?.toString() ?? "",
            levyTypes: data?.levyTypes?.toString() ?? "",
            // optionData?.levyTypeOptions
            //   ?.find((opt) => opt?.label === data?.levyTypes)
            //   ?.value?.toString() ?? "",
            levyAmount: Number(data?.levyAmount) || 0,
            pcpExpiryDate:
              parseExcelDateToISO(data?.pcpExpiryDate, "yyyy-MM-dd") ?? "",
            pcpClinic: data?.pcpClinic,
            typeOfVisa: "",
            purpose: "",
            remarks: "",
            frontImage: "",
            backImage: "",
            isActive: true,
            createUser: userData?.userName,
            createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            modifyUser: userData?.userName,
            modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
          },
        ];

        const employeeLogin = [
          {
            companyCode: 0,
            employeeID: 0,
            userName: data?.email,
            password: "12345",
            defaultLoginLatitude: 0,
            defaultLoginLongitude: 0,
            loginAttempts: 0,
            lastLogin: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            isActive: true,
            createUser: userData?.userName,
            createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            modifyUser: userData?.userName,
            modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            userType: "Employee",
            isLock: false,
            deviceId: "",
            DeviceIMEINumber: "",
            isFirstLogin: true,
          },
        ];

        const cpfAccountDetails = [
          {
            id: 0,
            companyCode: 0,
            employeeCode: 0,
            nric: "",
            employeeCPFAccountNumber: "",
            additionalCPFAccount: "",
            employerCPFAccount: "",
            cpfStatus: "",
            autoDetectCPF: true,
            includeIR8ASubmission: true,
            sdfRequired: true,
            voluntaryCPFContribution: 0,
            employeeAmount: 0,
            employerAmount: 0,
            createUser: userData?.userName,
            createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            modifyUser: userData?.userName,
            modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
            isActive: true,
          },
        ];

        const documentImageDetails = [
          {
            code: 0,
            companyCode: userData?.companyCode,
            employeeCode: 0,
            description: "",
            frontimage: "",
            backimage: "",
            expiryDate:
              parseExcelDateToISO(data?.passPortExpiryDate, "yyyy-MM-dd") ?? "",
            passportNumber: data?.passportNumber?.toString() ?? "",
            issuedDate:
              parseExcelDateToISO(data?.passPortIssuedDate, "yyyy-MM-dd") ?? "",
            issuedPlace: data?.passPortIssuedPlace,
            createUser: userData?.userName,
            createDate: getCurrentFormattedDate(),
            modifyUser: userData?.userName,
            modifyDate: getCurrentFormattedDate(),
            isActive: true,
          },
        ];

        const locationCode = data?.locationCode;

        delete data?.passIssuedDate;
        // const employmentStatus =
        //   optionData?.employmentStatusOptions?.find(
        //     (opt) => opt?.label === data?.employmentStatus
        //   )?.value ?? 0;
        return {
          ...data,
          employeeCode: 0,
          uniqueId: data?.uniqueId?.toString() ?? "",
          contractExpiryDate:
            parseExcelDateToISO(data?.contractExpiryDate, "yyyy-MM-dd") ?? "",
          dob: parseExcelDateToISO(data?.dob, "dd/MM/yyyy") ?? "",
          passIssueDate:
            parseExcelDateToISO(data?.passIssueDate, "yyyy-MM-dd") ?? "",
          workPermitRenewalDate:
            parseExcelDateToISO(data?.workPermitRenewalDate, "yyyy-MM-dd") ??
            "",
          resignedDate:
            parseExcelDateToISO(data?.resignedDate, "dd/MM/yyyy") ?? "",
          passPortExpiryDate:
            parseExcelDateToISO(data?.passPortExpiryDate, "yyyy-MM-dd") ?? "",
          passPortIssuedDate:
            parseExcelDateToISO(data?.passPortIssuedDate, "yyyy-MM-dd") ?? "",
          icno: "",
          officeNo: "",
          preferedName: "",
          surpervisorName: "",
          placeOfBirth: "",
          identification: "",
          relationship: "",
          userSecurity: "",
          claimsTypes: "",
          jobGrade: "",
          language1: "",
          language2: "",
          language3: "",
          publicHolidayGroup: "",
          companyCode: userData?.companyCode,
          mode: "I",
          dateFormat: "dd/mm/yyyy",
          clockInAndOutOnMobile: "True",
          superAdmin: false,
          basicPayAmountType: "SGD",
          dailyAllowance: 0,
          otPaidInDays: 0,
          salaryType: salaryType,
          daySalary: salaryType === "Daily" ? data?.salary : 0,
          hourlySalary: salaryType === "Hourly" ? data?.salary : 0,
          basicSalary: salaryType === "Monthly" ? data?.salary : 0,
          finNumber: data?.nricNumber?.toString() ?? "",
          accountNo: data?.accountNo?.toString() ?? "",
          postalCode: data?.postalCode?.toString() ?? "",
          locationCode: locationCode,
          emergencyContactPerson:
            data?.emergencyContactPerson?.toString() ?? "",
          joinDate: parseExcelDateToISO(data?.joinDate, "yyyy-MM-dd") ?? "",
          confirmationDate:
            parseExcelDateToISO(data?.confirmationDate, "yyyy-MM-dd") ?? "",
          probationPeriodStart:
            parseExcelDateToISO(data?.probationPeriodStart, "yyyy-MM-dd") ?? "",
          probationPeriodEnd:
            parseExcelDateToISO(data?.probationPeriodEnd, "yyyy-MM-dd") ?? "",
          hpno: data?.hpno?.toString() ?? "",

          // momTrade:
          //   optionData?.momTradeOptions
          //     ?.find((opt) => opt?.label === data?.momTrade)
          //     ?.value.toString() ?? "",
          // netcoTrade:
          //   optionData?.netcoTradeOptions
          //     ?.find((opt) => opt?.label === data?.netcoTrade)
          //     ?.value.toString() ?? "",
          // contractType:
          //   optionData?.contarctTypeOptions?.find(
          //     (opt) => opt?.label === data?.contractType
          //   )?.value ?? "",
          // defaultShift:
          //   optionData?.defaultShiftOptions?.find(
          //     (opt) => opt?.label === data?.defaultShift
          //   )?.value ?? 0,

          // departmentCode:
          //   optionData?.departmentOptions?.find(
          //     (opt) => opt?.label === data?.departmentCode
          //   )?.value ?? 0,
          // designationCode:
          //   optionData?.designationOptions?.find(
          //     (opt) => opt?.label === data?.designationCode
          //   )?.value ?? 0,
          // employeeType:
          //   optionData?.empTypeOptions?.find(
          //     (opt) => opt?.label === data?.employeeType
          //   )?.value ?? "",
          reportTo: data?.reportTo?.toString() ?? "",
          // employeeWorkType:
          //   optionData?.workingMode?.find(
          //     (opt) => opt?.label === data?.employeeWorkType
          //   )?.value ?? 0,
          // employmentType:
          //   optionData?.employmentTypeOptions?.find(
          //     (opt) => opt?.label === data?.employmentType
          //   )?.value ?? "",
          passCode: passCode,

          excludeTime: data?.excludeTime === "Yes" ? "true" : "false",
          nsEligible: data?.nsEligible === "Yes" ? true : false,
          // paymentMode:
          //   optionData?.paymodeOptions?.find(
          //     (opt) => opt?.label === data?.paymentMode
          //   )?.value ?? 0,
          // groups:
          //   optionData?.group
          //     ?.find((opt) => opt?.label === data?.groups)
          //     ?.value.toString() ?? "",

          maritalStatus:
            optionData?.marriagestatus?.find(
              (opt) => opt?.label === data?.maritalStatus
            )?.value ?? "",
          gender:
            optionData?.genders?.find((opt) => opt?.label === data?.gender)
              ?.value ?? "",
          havingDependants: data?.havingDependants === "Yes" ? true : false,
          havingKids: data?.havingKids === "Yes" ? true : false,
          // employmentStatus: Number(employmentStatus),
          // residentialType:
          //   optionData?.residentials?.find(
          //     (opt) => opt?.label === data?.residentialType
          //   )?.value ?? "",
          skilledOrUnSkilled:
            optionData?.skilledOrUnSkilledOptions?.find(
              (opt) => opt?.label === data?.skilledOrUnSkilled
            )?.value ?? "",
          // prcpfType:
          //   optionData?.prcpfTypeOptions?.find(
          //     (opt) => opt?.label === data?.prcpfType
          //   )?.value ?? "",
          // projectCode:
          //   optionData?.projectOptions
          //     ?.find((opt) => opt?.label === data?.projectCode)
          //     ?.value.toString() ?? "",
          // contributionCode:
          //   optionData?.contributionOptions?.find(
          //     (opt) => opt?.label === data?.contributionCode
          //   )?.value ?? 0,
          haveNeedAttendance: data?.haveNeedAttendance === "Yes" ? true : false,
          haveLoginPermission:
            data?.haveLoginPermission === "Yes" ? true : false,
          haveOverTimePay: data?.haveOverTimePay === "Yes" ? true : false,
          haveOverTimePayForExtraHours:
            data?.haveOverTimePayForExtraHours === "Yes" ? true : false,
          haveLessTimeDeduction:
            data?.haveLessTimeDeduction === "Yes" ? true : false,
          isActive: true,
          haveFullPay: data?.haveFullPay === "Yes" ? true : false,
          accommodationByCompany:
            data?.accommodationByCompany === "Yes" ? true : false,
          lengthofNoticePeriod:
            data?.lengthofNoticePeriod?.toString() === ""
              ? "0"
              : data?.lengthofNoticePeriod?.toString(),
          noofworkingDaysPerWeek:
            data?.noofworkingDaysPerWeek?.toString() || "",
          localContactNumber: data?.localContactNumber?.toString() || "",
          overseasContactNumber: data?.overseasContactNumber?.toString() || "",
          workingTimingPerDay: data?.workingTimingPerDay?.toString() || 0,
          otHourlySalary: data?.otHourlySalary || 0,
          otDaySalary: data?.otDaySalary || 0,
          createUser: userData?.userName,
          createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
          modifyUser: userData?.userName,
          modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
          oT1PayRate: data?.oT1PayRate || 0,
          oT2PayRate: data?.oT2PayRate || 0,
          oT3PayRate: data?.oT3PayRate || 0,
          extraHoursRate: data?.extraHoursRate || 0,
          monday: data?.monday || 0,
          tuesday: data?.tuesday || 0,
          wednesday: data?.wednesday || 0,
          thursday: data?.thursday || 0,
          friday: data?.friday || 0,
          saturday: data?.saturday || 0,
          sunday: data?.sunday || 0,
          mondayWorkingMode: data?.mondayWorkingMode?.toString() || "0",
          tuesdayWorkingMode: data?.tuesdayWorkingMode?.toString() || "0",
          wednesdayWorkingMode: data?.wednesdayWorkingMode?.toString() || "0",
          thursdayWorkingMode: data?.thursdayWorkingMode?.toString() || "0",
          fridayWorkingMode: data?.fridayWorkingMode?.toString() || "0",
          saturdayWorkingMode: data?.saturdayWorkingMode?.toString() || "0",
          sundayWorkingMode: data?.sundayWorkingMode?.toString() || "0",
          passTypeDetails: passTypeDetails,
          // cpfAccountDetails: cpfAccountDetails,
          employeeLogin: employeeLogin,
          workExperienceDetails: [],
          inventoryDetails: [],
          allowanceDetails: [],
          deductionDetails: [],
          educationalQualificationList: [],
          otherVisaDetails: [],
          accommodationDetail: [],
          employeeKidsDetail: [],
          dependantDetail: [],
          alternateWorkingHours: [],
          documentImageDetails: documentImageDetails,
          certificationsDetails: certificationsDetails,
          workDayPerWeek: data?.workDayPerWeek?.toString() || "",
          employeesLeaveDetails: empLeaveDetails || [],
          // country:
          //   optionData?.countryOptions?.find((opt) => opt.label === data.country)
          //     .value ?? "",
        };
      });
      setEmpData(finalData);

      validationSchema
        .validate(finalData)
        .then(() => {
          setEmployeeData(finalData);
          setUploadStatus("File processed successfully!");
        })
        .catch((err) => {
          setUploadStatus("Validation error: " + err.message);
        });
    };

    reader.readAsArrayBuffer(file);
  };

  // Function to remove the uploaded file
  const handleRemoveFile = () => {
    setUploadedFileName("");
    setEmployeeData(null);
    setUploadStatus("");
  };

  const importEmployeeData = () => {
    importEmployee(employeeData, {
      onSuccess: (data) => {
        if (data?.data[0].response === false) {
          toast.error(data?.data[0]?.errorMessage);
        } else {
          toast.success("Employee data imported successfully.");
          setTimeout(
            () => navigate(`${all_routes.employee}${all_routes.employee_list}`),
            2000
          );
        }
      },
      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
      },
    });
    setUploadedFileName("");
    setEmployeeData(null);
    setUploadStatus("");
  };
  const columns = [
    {
      title: "Emp Name",
      dataIndex: "fullName",
    },
    {
      title: "IC No",
      dataIndex: "icno",
    },
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
    },
    {
      title: "Gender",
      dataIndex: "gender",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "DOB",
      dataIndex: "dob",
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
    },
    {
      title: "Race",
      dataIndex: "race",
    },
    {
      title: "Religion",
      dataIndex: "religion",
    },
    {
      title: "Marital Status",
      dataIndex: "maritalStatus",
    },
    {
      title: "HP No",
      dataIndex: "hpno",
    },
    {
      title: "Local Contact No",
      dataIndex: "localContactNumber",
    },
    {
      title: "Overseas Contact No",
      dataIndex: "overseasContactNumber",
    },
    {
      title: "Address1",
      dataIndex: "address1",
    },
    {
      title: "Address2",
      dataIndex: "address2",
    },
    {
      title: "country",
      dataIndex: "country",
    },
    {
      title: "postalCode",
      dataIndex: "postalCode",
    },
    {
      title: "Status",
      dataIndex: "isActive",
    },
    {
      title: "Residential Type",
      dataIndex: "residentialType",
    },
    {
      title: "skilledOrUnSkilled",
      dataIndex: "skilledOrUnSkilled",
    },
    {
      title: "Salary Type",
      dataIndex: "salaryType",
    },
    {
      title: "Salary",
      dataIndex: "basicSalary",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
    },
    {
      title: "User Name",
      dataIndex: "uniqueId",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Import Employee</h4>
              <h6>Add Employees from excel sheet</h6>
            </div>
          </div>

          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.employee}${all_routes.employee_list}`}
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="modal-footer-btn download-file mb-3">
                  <button
                    // onClick={handleDownloadSample}
                    onClick={() => generateExcel({ optionData })}
                    className="btn btn-submit"
                    type="button"
                  >
                    Download Sample File
                  </button>
                  &nbsp;
                  <button
                    // onClick={handleDownloadSample}
                    onClick={importEmployeeData}
                    className="btn btn-submit"
                    type="button"
                    disabled={!uploadedFileName || employeeData?.length === 0}
                  >
                    Import
                  </button>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="input-blocks image-upload-down mb-10">
                  <label> Upload Excel File</label>
                  <div className="image-upload download">
                    {!uploadedFileName ? (
                      <>
                        <input
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={handleFileUpload}
                        />
                        <div className="image-uploads">
                          <ImageWithBasePath
                            src="assets/img/download-img.png"
                            alt="img"
                          />
                          <h4>
                            Drag and drop a <span>file to upload</span>
                          </h4>
                        </div>
                      </>
                    ) : (
                      <div className="uploaded-file-info">
                        <div className="image-uploads">
                          <p>Uploaded File: {uploadedFileName}</p>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={handleRemoveFile}
                          >
                            Remove File
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12" style={{ marginTop: "75px" }}>
                {uploadStatus && (
                  <div
                    className={`alert ${
                      uploadStatus.includes("Successfully")
                        ? "alert-success"
                        : "alert-info"
                    } mt-3`}
                  >
                    {uploadStatus}
                  </div>
                )}
              </div>
              <div className="col-lg-12">
                {/* {employeeData && (
                  <pre
                    className="alert alert-light mt-3"
                    style={{ maxHeight: "400px" }}
                  >
                    {JSON.stringify(employeeData, null, 2)}
                  </pre>
                )} */}
                <div className="table-responsive">
                  <Table
                    columns={columns}
                    dataSource={employeeData}
                    pagination={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportEmployee;
